import { z } from 'zod';
import { slugSchema } from './slug.js';
export const createOrganizationSchema = z.object({
    slug: slugSchema,
    name: z.string().min(1).max(255),
});
//# sourceMappingURL=organization.js.map